// extracted by mini-css-extract-plugin
export default {"spinners":"Spinners_spinners__7cWBx"};